import { render, staticRenderFns } from "./DraggableTabs.vue?vue&type=template&id=7e8e21ba&scoped=true&"
import script from "./DraggableTabs.vue?vue&type=script&lang=js&"
export * from "./DraggableTabs.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTabs.vue?vue&type=style&index=0&id=7e8e21ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e21ba",
  null
  
)

export default component.exports